<template>
    <div class="d-table-cell">
        <div class="border shadow-sm plan-card">
            <div class="font-22 text-semi-bold mb-3">{{ plan.name }}</div>
            <p class="font-12">{{ plan.description }}</p>

            <div class="mt-3 mb-4">
                <template v-if="Array.isArray(plan.options)">
                    <div v-if="plan.options[selectedOptionIdx]['isCustom']">
                        <div class="font-24 font-weight-bold">
                            {{ plan.options[selectedOptionIdx].title }}
                        </div>
                        <div class="font-16 font-weight-bold mt-2">
                            {{ plan.options[selectedOptionIdx].subtotal }}
                        </div>
                    </div>
                    <div v-else-if="plan.options[selectedOptionIdx]">
                        <div class="font-32 text-bold">
                            ${{ plan.options[selectedOptionIdx].annually }}
                        </div>
                        <div class="text-bold">per month billed annually</div>
                        <div class="text-muted mt-2 font-12">
                            or ${{ plan.options[selectedOptionIdx].monthly }}/month billed monthly
                        </div>
                        <div v-if="plan.options.length > 1">
                            <input
                                id="input"
                                type="range"
                                min="0"
                                v-model="selectedOptionIdx"
                                :max="plan.options.length - 1"
                                step="1"
                                class="slider mt-3">
                        </div>
                        <div v-if="plan.options[selectedOptionIdx].documents !== -1" class="text-bold mt-3">
                            {{ plan.options[selectedOptionIdx].documents }} documents per month
                        </div>
                    </div>
                </template>
            </div>
            <div v-if="plan.includes && getPlanById(plan.includes)" class="font-12 text-muted font-italic mt-2">
                Includes the futures in <span class="text-primary">{{ getPlanById(plan.includes).name }}</span> plan:
            </div>
            <div v-for="(feature, idx) in plan.features" :key="idx"
                 v-tooltip="feature.tooltip"
                 class="font-12 text-muted mt-2">
                {{ feature.name }}
            </div>

            <div class="action-btn">
                <button v-if="plan.action && plan.action.action"
                        v-loading.btn="isActionExecution"
                        @click="runAction"
                        :key="plan.action.action"
                        class="btn btn-sm btn-primary">
                    {{ plan.action.button }}
                </button>
            </div>
        </div>
        <div v-if="isFirst" class="text-left text-muted ml-3">
            * Prices exclude tax
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {ERROR} from '@/store/modules/ui/UI'
import {appHelpChat} from '@/services/chats'
/* eslint-disable no-throw-literal */
export default {
    name: 'BillingPlanCard',
    props: {
        plan: {
            type: Object,
            required: true
        },
        isFirst: {
            type: Boolean,
            default: false
        },
        getPlanById: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            selectedOptionIdx: 0,
            isActionExecution: false
        }
    },
    methods: {
        async runAction() {
            try {
                if (!this.plan.action.action) {
                    throw 'No action'
                }
                this.isActionExecution = true
                if (this.plan.action.action === 'CHAT') {
                    appHelpChat.show()
                } else if (this.plan.action.action === 'SET_PLAN') {
                    if (!this.plan.options[this.selectedOptionIdx] ||
                        !this.plan.options[this.selectedOptionIdx].uuid) {
                        throw 'No uuid'
                    }
                    await axios.post('teams/billing/plans', {
                        plan: this.plan.options[this.selectedOptionIdx].uuid
                    })
                    this.$emit('changed')
                }
            } catch (e) {
                this.$snackbar.show({type: ERROR})
            } finally {
                this.isActionExecution = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.plan-card {
    position: relative;
    text-align: left;
    vertical-align: top;
    width: 320px;
    height: 100%;
    margin: 0 8px 12px;
    font-size: 16px;
    border-radius: 3px;
    padding: 16px 24px 54px;
    border-bottom: 2px solid $color-grey-primary;
}

button {
    min-width: 120px;
}

.slider {
    -webkit-appearance: none;
    width: 100%;
    height: 5px;
    border-radius: 5px;
    background: #d3d3d3;
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
}

.slider:hover {
    opacity: 1;
}

.slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: $color-purple-light;
    cursor: pointer;
}

.action-btn {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
}
</style>
